export default __webpack_public_path__ + "static/media/BTMSCHOOLYEARS.c7f81941.png";